// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/risk_calc_engine_service.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's risk_calc_engine_service.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { AccountIMResult, CalculationInput, FloatingIMByAccount, FloatingIMByIndex, FloatingIMPositionEntry, ICSTargetProduct, PSRDataSource, SpanV2SpreadCreditMethod } from "./im_model_pb";
import { file_devtool_emodel_v1_im_model } from "./im_model_pb";
import type { ExposureProfile, ValuationMode, XVAConfig, XVAMetrics } from "./market_model_pb";
import { file_devtool_emodel_v1_market_model } from "./market_model_pb";
import type { MTMIssue, MTMTickerGroupResult, TickerGroup } from "./mtm_model_pb";
import { file_devtool_emodel_v1_mtm_model } from "./mtm_model_pb";
import type { CalculatePFERequest, CalculatePFEResponse } from "./pfe_service_pb";
import { file_devtool_emodel_v1_pfe_service } from "./pfe_service_pb";
import type { CalculatePFEMatrices, DailyPowerCostEntry, DistributionMatrices, PFEDataPrepConfig, PortfolioAnalysisResult, RiskCalcAggregationConfig, RiskCalcMarketData, RiskCalcOutputConfig, RiskCalcPricingConfig, RiskCalcTradeData, SelectedDistributionMatrices, SIMResultAndDetail } from "./risk_calc_engine_model_pb";
import { file_devtool_emodel_v1_risk_calc_engine_model } from "./risk_calc_engine_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/risk_calc_engine_service.proto.
 */
export const file_devtool_emodel_v1_risk_calc_engine_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_im_model, file_devtool_emodel_v1_market_model, file_devtool_emodel_v1_mtm_model, file_devtool_emodel_v1_pfe_service, file_devtool_emodel_v1_risk_calc_engine_model, file_google_type_date]);

/**
 * CalculateRiskリクエスト（Go RiskCalcEngineInput + CalculateByPortfolioInput 相当）
 *
 * @generated from message devtool.emodel.v1.CalculateRiskRequest
 */
export type CalculateRiskRequest = Message<"devtool.emodel.v1.CalculateRiskRequest"> & {
  /**
   * 基準日（計算の開始日）
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * 日次マーケットデータ
   *
   * @generated from field: devtool.emodel.v1.RiskCalcMarketData market_data = 2;
   */
  marketData?: RiskCalcMarketData;

  /**
   * ポジションデータ
   *
   * @generated from field: devtool.emodel.v1.RiskCalcTradeData trade_data = 3;
   */
  tradeData?: RiskCalcTradeData;

  /**
   * プライシング設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcPricingConfig pricing_config = 4;
   */
  pricingConfig?: RiskCalcPricingConfig;

  /**
   * 集計設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcAggregationConfig aggregation_config = 5;
   */
  aggregationConfig?: RiskCalcAggregationConfig;

  /**
   * 出力設定
   *
   * @generated from field: devtool.emodel.v1.RiskCalcOutputConfig output_config = 6;
   */
  outputConfig?: RiskCalcOutputConfig;

  /**
   * トランザクションベースの入力モード（設定時はemodel内でpositions/power costs等を計算）
   *
   * @generated from field: optional devtool.emodel.v1.PFEDataPrepConfig raw_trade_data = 10;
   */
  rawTradeData?: PFEDataPrepConfig;

  /**
   * Valuation mode: LEGACY (default) or NPV_DRIVEN (ORE-style NPV cube approach)
   *
   * @generated from field: optional devtool.emodel.v1.ValuationMode valuation_mode = 11;
   */
  valuationMode?: ValuationMode;

  /**
   * XVA configuration (only used with NPV_DRIVEN mode)
   *
   * @generated from field: optional devtool.emodel.v1.XVAConfig xva_config = 12;
   */
  xvaConfig?: XVAConfig;
};

/**
 * Describes the message devtool.emodel.v1.CalculateRiskRequest.
 * Use `create(CalculateRiskRequestSchema)` to create a new message.
 */
export const CalculateRiskRequestSchema: GenMessage<CalculateRiskRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 0);

/**
 * CalculateRiskレスポンス（Go RiskCalcEngineResponse + PortfolioPFESimResults 相当）
 *
 * @generated from message devtool.emodel.v1.CalculateRiskResponse
 */
export type CalculateRiskResponse = Message<"devtool.emodel.v1.CalculateRiskResponse"> & {
  /**
   * SIMResult配列（常に含まれる、sim_result_config指定時）
   *
   * @generated from field: repeated devtool.emodel.v1.SIMResultAndDetail sim_results = 1;
   */
  simResults: SIMResultAndDetail[];

  /**
   * CalculatePFEResult相当（detail_level >= FULL_MATRICES の場合）
   *
   * @generated from field: optional devtool.emodel.v1.CalculatePFEMatrices pfe_matrices = 2;
   */
  pfeMatrices?: CalculatePFEMatrices;

  /**
   * DistributionMatrix相当（detail_level >= FULL_MATRICES の場合）
   *
   * @generated from field: optional devtool.emodel.v1.DistributionMatrices distribution_matrices = 3;
   */
  distributionMatrices?: DistributionMatrices;

  /**
   * SelectedPnlDistributionMatrix相当（detail_level >= DETAILED の場合）
   *
   * @generated from field: optional devtool.emodel.v1.SelectedDistributionMatrices selected_distribution_matrices = 4;
   */
  selectedDistributionMatrices?: SelectedDistributionMatrices;

  /**
   * リクエストID（トレース用）
   *
   * @generated from field: string request_id = 5;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 6;
   */
  runtimeMs: number;

  /**
   * 実際に使用された評価日数
   *
   * @generated from field: int32 evaluation_days = 7;
   */
  evaluationDays: number;

  /**
   * 実際に使用された評価データ数
   *
   * @generated from field: int32 evaluation_data_count = 8;
   */
  evaluationDataCount: number;

  /**
   * Floating現在MTM合計
   *
   * @generated from field: double floating_current_mtm = 10;
   */
  floatingCurrentMtm: number;

  /**
   * Floating現在MTM配列（ポジション毎）
   *
   * @generated from field: repeated double floating_current_mtm_by_position = 11;
   */
  floatingCurrentMtmByPosition: number[];

  /**
   * Exposure profile (EPE/ENE/PFE curves)
   *
   * @generated from field: optional devtool.emodel.v1.ExposureProfile exposure_profile = 20;
   */
  exposureProfile?: ExposureProfile;

  /**
   * XVA metrics (CVA/DVA/FVA)
   *
   * @generated from field: optional devtool.emodel.v1.XVAMetrics xva_metrics = 21;
   */
  xvaMetrics?: XVAMetrics;
};

/**
 * Describes the message devtool.emodel.v1.CalculateRiskResponse.
 * Use `create(CalculateRiskResponseSchema)` to create a new message.
 */
export const CalculateRiskResponseSchema: GenMessage<CalculateRiskResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 1);

/**
 * PortfolioAnalysisResult生成リクエスト
 *
 * @generated from message devtool.emodel.v1.GetPortfolioAnalysisResultsRequest
 */
export type GetPortfolioAnalysisResultsRequest = Message<"devtool.emodel.v1.GetPortfolioAnalysisResultsRequest"> & {
  /**
   * SIMResult配列（CalculateRiskの出力から）
   *
   * @generated from field: repeated devtool.emodel.v1.SIMResultAndDetail sim_results = 1;
   */
  simResults: SIMResultAndDetail[];

  /**
   * ケースID
   *
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * 組織ID配列
   *
   * @generated from field: repeated string organization_ids = 3;
   */
  organizationIds: string[];

  /**
   * 組織名配列
   *
   * @generated from field: repeated string organization_names = 4;
   */
  organizationNames: string[];

  /**
   * 変動電力コスト（日次）
   *
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry unfixed_power_costs = 5;
   */
  unfixedPowerCosts: DailyPowerCostEntry[];
};

/**
 * Describes the message devtool.emodel.v1.GetPortfolioAnalysisResultsRequest.
 * Use `create(GetPortfolioAnalysisResultsRequestSchema)` to create a new message.
 */
export const GetPortfolioAnalysisResultsRequestSchema: GenMessage<GetPortfolioAnalysisResultsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 2);

/**
 * PortfolioAnalysisResult生成レスポンス
 *
 * @generated from message devtool.emodel.v1.GetPortfolioAnalysisResultsResponse
 */
export type GetPortfolioAnalysisResultsResponse = Message<"devtool.emodel.v1.GetPortfolioAnalysisResultsResponse"> & {
  /**
   * 分析結果配列
   *
   * @generated from field: repeated devtool.emodel.v1.PortfolioAnalysisResult results = 1;
   */
  results: PortfolioAnalysisResult[];

  /**
   * リクエストID
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 3;
   */
  runtimeMs: number;
};

/**
 * Describes the message devtool.emodel.v1.GetPortfolioAnalysisResultsResponse.
 * Use `create(GetPortfolioAnalysisResultsResponseSchema)` to create a new message.
 */
export const GetPortfolioAnalysisResultsResponseSchema: GenMessage<GetPortfolioAnalysisResultsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 3);

/**
 * Floating IM計算リクエスト（ヒストリカルシミュレーション方式）
 *
 * @generated from message devtool.emodel.v1.CalculateFloatingIMRequest
 */
export type CalculateFloatingIMRequest = Message<"devtool.emodel.v1.CalculateFloatingIMRequest"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * ポジション一覧
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMPositionEntry positions = 2;
   */
  positions: FloatingIMPositionEntry[];

  /**
   * 観測期間（日数）。0以下の場合は利用可能な全データを使用
   *
   * @generated from field: int32 observation_period = 3;
   */
  observationPeriod: number;

  /**
   * 信頼水準（basis points単位。例: 9750 = 97.5%）。0の場合はデフォルト9750
   *
   * @generated from field: int32 confidence_level_bps = 4;
   */
  confidenceLevelBps: number;

  /**
   * 調整係数。0の場合はデフォルト1.0
   *
   * @generated from field: double adjustment_factor = 5;
   */
  adjustmentFactor: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateFloatingIMRequest.
 * Use `create(CalculateFloatingIMRequestSchema)` to create a new message.
 */
export const CalculateFloatingIMRequestSchema: GenMessage<CalculateFloatingIMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 4);

/**
 * Floating IM計算レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateFloatingIMResponse
 */
export type CalculateFloatingIMResponse = Message<"devtool.emodel.v1.CalculateFloatingIMResponse"> & {
  /**
   * 合計Floating IM
   *
   * @generated from field: double total_floating_im = 1;
   */
  totalFloatingIm: number;

  /**
   * インデックス別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByIndex im_by_index = 2;
   */
  imByIndex: FloatingIMByIndex[];

  /**
   * 口座別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByAccount im_by_account = 3;
   */
  imByAccount: FloatingIMByAccount[];

  /**
   * 使用されたパーセンタイル（basis points単位。例: 9750 = 97.5%）
   *
   * @generated from field: int32 used_percentile_bps = 4;
   */
  usedPercentileBps: number;

  /**
   * 使用された観測期間
   *
   * @generated from field: int32 used_observation_period = 5;
   */
  usedObservationPeriod: number;

  /**
   * 使用された調整係数
   *
   * @generated from field: double used_adjustment_factor = 6;
   */
  usedAdjustmentFactor: number;

  /**
   * リクエストID
   *
   * @generated from field: string request_id = 7;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 8;
   */
  runtimeMs: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateFloatingIMResponse.
 * Use `create(CalculateFloatingIMResponseSchema)` to create a new message.
 */
export const CalculateFloatingIMResponseSchema: GenMessage<CalculateFloatingIMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 5);

/**
 * 統合 IM 計算リクエスト
 *
 * @generated from message devtool.emodel.v1.CalculateCombinedIMRequest
 */
export type CalculateCombinedIMRequest = Message<"devtool.emodel.v1.CalculateCombinedIMRequest"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * ポジション一覧（Floating IM と電力 IM の両方に使用）
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMPositionEntry positions = 2;
   */
  positions: FloatingIMPositionEntry[];

  /**
   * Floating IM パラメータ: 観測期間（日数）。0以下の場合は利用可能な全データを使用
   *
   * @generated from field: int32 observation_period = 3;
   */
  observationPeriod: number;

  /**
   * Floating IM パラメータ: 信頼水準（basis points単位）。0の場合はデフォルト9750
   *
   * @generated from field: int32 confidence_level_bps = 4;
   */
  confidenceLevelBps: number;

  /**
   * Floating IM パラメータ: 調整係数。0の場合はデフォルト1.0
   *
   * @generated from field: double adjustment_factor = 5;
   */
  adjustmentFactor: number;

  /**
   * 電力 IM パラメータ: PSRデータソース
   *
   * @generated from field: devtool.emodel.v1.PSRDataSource psr_data_source = 6;
   */
  psrDataSource: PSRDataSource;

  /**
   * 電力 IM パラメータ: ICSルックバック日数
   *
   * @generated from field: optional int32 ics_lookback_days = 7;
   */
  icsLookbackDays?: number;

  /**
   * PSRデータ参照日。未指定の場合は base_date をデフォルトとする
   *
   * @generated from field: optional google.type.Date data_reference_date = 8;
   */
  dataReferenceDate?: Date;

  /**
   * ICSターゲットプロダクト。指定された area + hour_type ペアのみICSクレジットを適用。空の場合は全ICS有効（後方互換）
   *
   * @generated from field: repeated devtool.emodel.v1.ICSTargetProduct ics_target_products = 10;
   */
  icsTargetProducts: ICSTargetProduct[];

  /**
   * true の場合、SPAN V2 が実際に使った PSR / Spread / Position の入力スナップショットを
   * レスポンスに同梱する。Power IM (SPAN V2) パスでのみ有効。
   *
   * @generated from field: optional bool with_calculation_input = 11;
   */
  withCalculationInput?: boolean;

  /**
   * SPAN V2 のスプレッドクレジットの方式。未指定の場合は
   * SPAN_V2_SPREAD_CREDIT_METHOD_ABSOLUTE_QUANTITY（v1.0）で計算する。
   * 実際に使った方式は SPANV2Result.spread_credit_method に返る。
   *
   * @generated from field: devtool.emodel.v1.SpanV2SpreadCreditMethod span_v2_spread_credit_method = 12;
   */
  spanV2SpreadCreditMethod: SpanV2SpreadCreditMethod;
};

/**
 * Describes the message devtool.emodel.v1.CalculateCombinedIMRequest.
 * Use `create(CalculateCombinedIMRequestSchema)` to create a new message.
 */
export const CalculateCombinedIMRequestSchema: GenMessage<CalculateCombinedIMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 6);

/**
 * 統合 IM 計算レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateCombinedIMResponse
 */
export type CalculateCombinedIMResponse = Message<"devtool.emodel.v1.CalculateCombinedIMResponse"> & {
  /**
   * リクエストID
   *
   * @generated from field: string request_id = 4;
   */
  requestId: string;

  /**
   * 計算時間（ミリ秒）
   *
   * @generated from field: int32 runtime_ms = 5;
   */
  runtimeMs: number;

  /**
   * アカウント別 IM 結果
   *
   * @generated from field: repeated devtool.emodel.v1.AccountIMResult results = 6;
   */
  results: AccountIMResult[];

  /**
   * 計算基準日（リクエストの base_date）
   *
   * @generated from field: google.type.Date calculation_date = 7;
   */
  calculationDate?: Date;

  /**
   * PSRデータ参照日（実際に使用された日付）
   *
   * @generated from field: google.type.Date data_reference_date = 8;
   */
  dataReferenceDate?: Date;

  /**
   * SPAN V2 が実際に使った PSR / Spread / Position の入力スナップショット。
   * リクエストで with_calculation_input=true のときのみセットされる。
   *
   * @generated from field: optional devtool.emodel.v1.CalculationInput calculation_input = 9;
   */
  calculationInput?: CalculationInput;
};

/**
 * Describes the message devtool.emodel.v1.CalculateCombinedIMResponse.
 * Use `create(CalculateCombinedIMResponseSchema)` to create a new message.
 */
export const CalculateCombinedIMResponseSchema: GenMessage<CalculateCombinedIMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 7);

/**
 * @generated from message devtool.emodel.v1.UnifiedAnalysisIssue
 */
export type UnifiedAnalysisIssue = Message<"devtool.emodel.v1.UnifiedAnalysisIssue"> & {
  /**
   * @generated from field: devtool.emodel.v1.UnifiedAnalysisComponent component = 1;
   */
  component: UnifiedAnalysisComponent;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message devtool.emodel.v1.UnifiedAnalysisIssue.
 * Use `create(UnifiedAnalysisIssueSchema)` to create a new message.
 */
export const UnifiedAnalysisIssueSchema: GenMessage<UnifiedAnalysisIssue> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 8);

/**
 * @generated from message devtool.emodel.v1.RunUnifiedAnalysisRequest
 */
export type RunUnifiedAnalysisRequest = Message<"devtool.emodel.v1.RunUnifiedAnalysisRequest"> & {
  /**
   * @generated from field: optional devtool.emodel.v1.CalculateRiskRequest risk_request = 1;
   */
  riskRequest?: CalculateRiskRequest;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculatePFERequest quick_pfe_request = 3;
   */
  quickPfeRequest?: CalculatePFERequest;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateCombinedIMRequest combined_im_request = 4;
   */
  combinedImRequest?: CalculateCombinedIMRequest;
};

/**
 * Describes the message devtool.emodel.v1.RunUnifiedAnalysisRequest.
 * Use `create(RunUnifiedAnalysisRequestSchema)` to create a new message.
 */
export const RunUnifiedAnalysisRequestSchema: GenMessage<RunUnifiedAnalysisRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 9);

/**
 * @generated from message devtool.emodel.v1.RunUnifiedAnalysisResponse
 */
export type RunUnifiedAnalysisResponse = Message<"devtool.emodel.v1.RunUnifiedAnalysisResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: int32 runtime_ms = 2;
   */
  runtimeMs: number;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateRiskResponse risk_response = 3;
   */
  riskResponse?: CalculateRiskResponse;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculatePFEResponse quick_pfe_response = 5;
   */
  quickPfeResponse?: CalculatePFEResponse;

  /**
   * @generated from field: optional devtool.emodel.v1.CalculateCombinedIMResponse combined_im_response = 6;
   */
  combinedImResponse?: CalculateCombinedIMResponse;

  /**
   * @generated from field: repeated devtool.emodel.v1.UnifiedAnalysisIssue issues = 7;
   */
  issues: UnifiedAnalysisIssue[];

  /**
   * @generated from field: int32 requested_components = 8;
   */
  requestedComponents: number;

  /**
   * @generated from field: int32 successful_components = 9;
   */
  successfulComponents: number;
};

/**
 * Describes the message devtool.emodel.v1.RunUnifiedAnalysisResponse.
 * Use `create(RunUnifiedAnalysisResponseSchema)` to create a new message.
 */
export const RunUnifiedAnalysisResponseSchema: GenMessage<RunUnifiedAnalysisResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 10);

/**
 * CalculateMTMリクエスト
 *
 * @generated from message devtool.emodel.v1.CalculateMTMRequest
 */
export type CalculateMTMRequest = Message<"devtool.emodel.v1.CalculateMTMRequest"> & {
  /**
   * 基準日（カーブ選択に使用）
   *
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * tickerごとにグルーピングされたポジション + 確定済み市場価格
   *
   * @generated from field: repeated devtool.emodel.v1.TickerGroup ticker_groups = 2;
   */
  tickerGroups: TickerGroup[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateMTMRequest.
 * Use `create(CalculateMTMRequestSchema)` to create a new message.
 */
export const CalculateMTMRequestSchema: GenMessage<CalculateMTMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 11);

/**
 * CalculateMTMレスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateMTMResponse
 */
export type CalculateMTMResponse = Message<"devtool.emodel.v1.CalculateMTMResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.MTMTickerGroupResult ticker_group_results = 1;
   */
  tickerGroupResults: MTMTickerGroupResult[];

  /**
   * @generated from field: int32 runtime_ms = 2;
   */
  runtimeMs: number;

  /**
   * @generated from field: repeated devtool.emodel.v1.MTMIssue issues = 3;
   */
  issues: MTMIssue[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateMTMResponse.
 * Use `create(CalculateMTMResponseSchema)` to create a new message.
 */
export const CalculateMTMResponseSchema: GenMessage<CalculateMTMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 12);

/**
 * @generated from message devtool.emodel.v1.QueryPriceTimeSeriesRequest
 */
export type QueryPriceTimeSeriesRequest = Message<"devtool.emodel.v1.QueryPriceTimeSeriesRequest"> & {
  /**
   * シンボル（e.g. "TOKYO_BASE"）
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * 限月（e.g. 2026-04-01）
   *
   * @generated from field: google.type.Date contract_month = 2;
   */
  contractMonth?: Date;
};

/**
 * Describes the message devtool.emodel.v1.QueryPriceTimeSeriesRequest.
 * Use `create(QueryPriceTimeSeriesRequestSchema)` to create a new message.
 */
export const QueryPriceTimeSeriesRequestSchema: GenMessage<QueryPriceTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 13);

/**
 * @generated from message devtool.emodel.v1.QueryPriceTimeSeriesResponse
 */
export type QueryPriceTimeSeriesResponse = Message<"devtool.emodel.v1.QueryPriceTimeSeriesResponse"> & {
  /**
   * 時系列データ
   *
   * @generated from field: repeated devtool.emodel.v1.PriceTimeSeriesPoint points = 1;
   */
  points: PriceTimeSeriesPoint[];

  /**
   * シンボル
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * 限月
   *
   * @generated from field: google.type.Date contract_month = 3;
   */
  contractMonth?: Date;
};

/**
 * Describes the message devtool.emodel.v1.QueryPriceTimeSeriesResponse.
 * Use `create(QueryPriceTimeSeriesResponseSchema)` to create a new message.
 */
export const QueryPriceTimeSeriesResponseSchema: GenMessage<QueryPriceTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 14);

/**
 * PriceTimeSeriesPoint: 1日分の価格ポイント
 *
 * @generated from message devtool.emodel.v1.PriceTimeSeriesPoint
 */
export type PriceTimeSeriesPoint = Message<"devtool.emodel.v1.PriceTimeSeriesPoint"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Forward価格
   *
   * @generated from field: double price = 2;
   */
  price: number;
};

/**
 * Describes the message devtool.emodel.v1.PriceTimeSeriesPoint.
 * Use `create(PriceTimeSeriesPointSchema)` to create a new message.
 */
export const PriceTimeSeriesPointSchema: GenMessage<PriceTimeSeriesPoint> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 15);

/**
 * UpsertForwardCurveリクエスト
 *
 * @generated from message devtool.emodel.v1.UpsertForwardCurveRequest
 */
export type UpsertForwardCurveRequest = Message<"devtool.emodel.v1.UpsertForwardCurveRequest"> & {
  /**
   * カーブ識別子（GCS パスと forward_curve_metadata.ticker のキー。
   * 例: "ENECHAIN_TOKYO_BASE_MONTH"）。opaque な文字列で、命名は呼び出し側の責務
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * スナップショット日（カーブの基準日）
   *
   * @generated from field: google.type.Date available_date = 2;
   */
  availableDate?: Date;

  /**
   * カーブデータ点。CSV にはリクエスト順のまま書かれる
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurvePoint points = 3;
   */
  points: ForwardCurvePoint[];

  /**
   * 任意メモ。呼び出し元サービス名などの provenance を残す
   *
   * @generated from field: string memo = 4;
   */
  memo: string;

  /**
   * 各点が表す期間（tenor）。点の日付はその期間の開始日でなければならない。必須（未指定は InvalidArgument）。
   * MTM（CalculateMTM / CalculatePowerMTM）は記録された tenor で価格を引く
   *
   * @generated from field: devtool.emodel.v1.ForwardCurveTenor tenor = 5;
   */
  tenor: ForwardCurveTenor;
};

/**
 * Describes the message devtool.emodel.v1.UpsertForwardCurveRequest.
 * Use `create(UpsertForwardCurveRequestSchema)` to create a new message.
 */
export const UpsertForwardCurveRequestSchema: GenMessage<UpsertForwardCurveRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 16);

/**
 * ForwardCurvePoint: 1点分の (日付, 価格)
 *
 * @generated from message devtool.emodel.v1.ForwardCurvePoint
 */
export type ForwardCurvePoint = Message<"devtool.emodel.v1.ForwardCurvePoint"> & {
  /**
   * 日付（通常は限月の月初）
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * 価格
   *
   * @generated from field: double price = 2;
   */
  price: number;
};

/**
 * Describes the message devtool.emodel.v1.ForwardCurvePoint.
 * Use `create(ForwardCurvePointSchema)` to create a new message.
 */
export const ForwardCurvePointSchema: GenMessage<ForwardCurvePoint> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 17);

/**
 * UpsertForwardCurveレスポンス
 *
 * @generated from message devtool.emodel.v1.UpsertForwardCurveResponse
 */
export type UpsertForwardCurveResponse = Message<"devtool.emodel.v1.UpsertForwardCurveResponse"> & {
  /**
   * metadata に記録した contract month 範囲（points の日付の min/max）
   *
   * @generated from field: google.type.Date contract_month_from = 1;
   */
  contractMonthFrom?: Date;

  /**
   * @generated from field: google.type.Date contract_month_to = 2;
   */
  contractMonthTo?: Date;

  /**
   * 書き込んだデータ点数
   *
   * @generated from field: int32 point_count = 3;
   */
  pointCount: number;
};

/**
 * Describes the message devtool.emodel.v1.UpsertForwardCurveResponse.
 * Use `create(UpsertForwardCurveResponseSchema)` to create a new message.
 */
export const UpsertForwardCurveResponseSchema: GenMessage<UpsertForwardCurveResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 18);

/**
 * GetForwardCurvesリクエスト
 *
 * @generated from message devtool.emodel.v1.GetForwardCurvesRequest
 */
export type GetForwardCurvesRequest = Message<"devtool.emodel.v1.GetForwardCurvesRequest"> & {
  /**
   * 基準日。ticker ごとに、この日以前で最新のスナップショットを返す
   *
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * カーブ識別子（forward_curve_metadata.ticker。例: "ENECHAIN_TOKYO_BASE_MONTH"、floating の指標の ticker）
   *
   * @generated from field: repeated string tickers = 2;
   */
  tickers: string[];
};

/**
 * Describes the message devtool.emodel.v1.GetForwardCurvesRequest.
 * Use `create(GetForwardCurvesRequestSchema)` to create a new message.
 */
export const GetForwardCurvesRequestSchema: GenMessage<GetForwardCurvesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 19);

/**
 * GetForwardCurvesレスポンス
 *
 * @generated from message devtool.emodel.v1.GetForwardCurvesResponse
 */
export type GetForwardCurvesResponse = Message<"devtool.emodel.v1.GetForwardCurvesResponse"> & {
  /**
   * ticker ごとのカーブ（リクエストの tickers の順に、ticker ごとにちょうど1つ。基準日以前にスナップショットが無い ticker は、
   * available_date を未設定・points を空にして返す）
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurve curves = 1;
   */
  curves: ForwardCurve[];
};

/**
 * Describes the message devtool.emodel.v1.GetForwardCurvesResponse.
 * Use `create(GetForwardCurvesResponseSchema)` to create a new message.
 */
export const GetForwardCurvesResponseSchema: GenMessage<GetForwardCurvesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 20);

/**
 * ForwardCurve: 1 ticker の forward curve のスナップショット
 *
 * @generated from message devtool.emodel.v1.ForwardCurve
 */
export type ForwardCurve = Message<"devtool.emodel.v1.ForwardCurve"> & {
  /**
   * カーブ識別子
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * スナップショット日（基準日以前にスナップショットが無ければ未設定）
   *
   * @generated from field: google.type.Date available_date = 2;
   */
  availableDate?: Date;

  /**
   * メタデータの限月の範囲（スナップショットのデータ点の日付の最小・最大。スナップショットが無い、または範囲が記録されていない
   * 古いスナップショットなら未設定）
   *
   * @generated from field: google.type.Date contract_month_from = 3;
   */
  contractMonthFrom?: Date;

  /**
   * @generated from field: google.type.Date contract_month_to = 4;
   */
  contractMonthTo?: Date;

  /**
   * カーブデータ点。点の日付と価格はスナップショットに保存されたまま（月初に寄せたりしない）で、並びは日付の昇順に並べ替える
   * （UpsertForwardCurve は点を依頼の順のまま保存するので、保存された順とは限らない）。同じ日付の点は保存された順
   *
   * @generated from field: repeated devtool.emodel.v1.ForwardCurvePoint points = 5;
   */
  points: ForwardCurvePoint[];

  /**
   * スナップショットの各点が表す期間（tenor）。点の日付はその期間の開始日。
   * すべてのスナップショットに記録されている
   *
   * @generated from field: devtool.emodel.v1.ForwardCurveTenor tenor = 6;
   */
  tenor: ForwardCurveTenor;
};

/**
 * Describes the message devtool.emodel.v1.ForwardCurve.
 * Use `create(ForwardCurveSchema)` to create a new message.
 */
export const ForwardCurveSchema: GenMessage<ForwardCurve> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_service, 21);

/**
 * @generated from enum devtool.emodel.v1.UnifiedAnalysisComponent
 */
export enum UnifiedAnalysisComponent {
  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_RISK = 1;
   */
  RISK = 1,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_QUICK_PFE = 3;
   */
  QUICK_PFE = 3,

  /**
   * @generated from enum value: UNIFIED_ANALYSIS_COMPONENT_COMBINED_IM = 4;
   */
  COMBINED_IM = 4,
}

/**
 * Describes the enum devtool.emodel.v1.UnifiedAnalysisComponent.
 */
export const UnifiedAnalysisComponentSchema: GenEnum<UnifiedAnalysisComponent> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 0);

/**
 * ForwardCurveTenor: フォワードカーブの 1 点が表す期間。点の日付は期間の開始日。
 * 建玉の受渡期間の区分（PowerDeliveryPeriodType）とは別の概念で、カーブの点の粒度を表す
 *
 * @generated from enum devtool.emodel.v1.ForwardCurveTenor
 */
export enum ForwardCurveTenor {
  /**
   * 未指定（tenor の記録が無い）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 月（点の日付は月初）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_MONTH = 1;
   */
  MONTH = 1,

  /**
   * 四半期（4〜6 月・7〜9 月・10〜12 月・1〜3 月。点の日付は四半期の初日）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_QUARTER = 2;
   */
  QUARTER = 2,

  /**
   * 半期（4〜9 月・10〜3 月。点の日付は半期の初日）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_SEASON = 3;
   */
  SEASON = 3,

  /**
   * 年度（4/1 始まりの 1 年。点の日付は 4/1）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_FISCAL_YEAR = 4;
   */
  FISCAL_YEAR = 4,

  /**
   * 12〜2 月（点の日付は 12/1）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_DEC_FEB = 5;
   */
  DEC_FEB = 5,

  /**
   * 日（受渡日ごとの点）
   *
   * @generated from enum value: FORWARD_CURVE_TENOR_DAY = 6;
   */
  DAY = 6,
}

/**
 * Describes the enum devtool.emodel.v1.ForwardCurveTenor.
 */
export const ForwardCurveTenorSchema: GenEnum<ForwardCurveTenor> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_service, 1);

